import React from "react"
import { useSiteMetadata } from "../hook/use-site-metadata"
import { normalizeZuseSiteUrl } from "../utils/site-url"

const SEO = ({ title, description, pathname, children, pageSeo, ogType = "website" }) => {
  const { title: defaultTitle, description: defaultDescription, image, siteUrl, twitterUsername, keywords } = useSiteMetadata()
  let seo = {};

  const seoMetaSocial = Array.isArray(pageSeo?.seo?.metaSocial) ? pageSeo.seo.metaSocial : null;
  const rootMetaSocial = Array.isArray(pageSeo?.metaSocial) ? pageSeo.metaSocial : null;

  let metaFacebook = seoMetaSocial
    ? seoMetaSocial.find(e => e.socialNetwork === "Facebook")
    : rootMetaSocial
      ? rootMetaSocial.find(e => e.socialNetwork === "Facebook")
      : null;

  let metaTwitter = seoMetaSocial
    ? seoMetaSocial.find(e => e.socialNetwork === "Twitter")
    : rootMetaSocial
      ? rootMetaSocial.find(e => e.socialNetwork === "Twitter")
      : null;

  if (!pageSeo) {

    seo = {
      metaTitle: defaultTitle,
      metaDescription: description || defaultDescription,
      image: image,
      url: `${siteUrl}${pathname || ``}`,
      twitterUsername,
      keywords
    }
  } else {
    seo = pageSeo.seo ? pageSeo.seo : pageSeo
  }

  if (seo.canonicalURL) {
    seo.canonicalURL = normalizeZuseSiteUrl(seo.canonicalURL);
  }

  if (seo.canonicalURL && ogType === "article") {
    try {
      const url = new URL(seo.canonicalURL);
      const siteHostname = new URL(siteUrl).hostname;
      if (url.hostname.includes(siteHostname) && !url.pathname.startsWith("/blog/")) {
        const slug = url.pathname.replace(/^\/+/, "").replace(/\/+$/, "");
        if (slug) url.pathname = `/blog/${slug}`;
        seo.canonicalURL = url.toString();
      }
    } catch (_) { /* leave as-is if URL parsing fails */ }
  }

  if (seo.metaRobots && seo.metaRobots.includes("<meta")) {
    const match = seo.metaRobots.match(/content="([^"]+)"/);
    if (match) seo.metaRobots = match[1];
  }

  let ContactImage = pageSeo?.seo ? pageSeo?.seo?.metaImage?.url ? pageSeo?.seo?.metaImage?.url : pageSeo?.page_thumbnail?.url : pageSeo?.metaImage?.url ? pageSeo?.metaImage?.url : pageSeo?.page_thumbnail?.url
  return (
    <>
      <title>{seo.metaTitle} </title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="description" content={seo.metaDescription} />
      <meta name="keywords" content={seo.keywords} />
      <meta name="robots" content={seo?.metaRobots ? seo?.metaRobots : "index, follow"} />
      {seo?.canonicalURL ? <link rel="canonical" href={seo.canonicalURL} /> : ''}

      <meta name="image" content={ContactImage} />

      {
        metaTwitter ?
          <>
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={metaTwitter?.title} />
            <meta name="twitter:url" content={seo.canonicalURL} />
            <meta name="twitter:description" content={metaTwitter?.description} />
            <meta name="twitter:image" content={metaTwitter?.image?.url ? metaTwitter?.image?.url : ""} />
          </> : ""
      }

      {
        metaFacebook ?
          <>
            <meta property="og:type" content={ogType} />
            <meta property="og:url" content={seo.canonicalURL} />
            <meta property="og:title" content={metaFacebook?.title} />
            <meta property="og:description" content={metaFacebook?.description} />
            <meta property="og:image" content={metaFacebook?.image?.url ? metaFacebook?.image?.url : ""} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
          </> : ""
      }


      {children}
    </>
  )
}
export default SEO